<template>
    <div>
        <b-alert variant="warning" show>
            <h5>RandomChat: Open Beta Test</h5>
            Random chat is open for testing! Our newest feature is under
            development, and we're testing it on various platforms for free for
            a limited time, let us know if you have any feedback, thanks!
        </b-alert>
        <random-chat-cordova v-if="cordova" />
        <random-chat-match v-else />
    </div>
</template>

<script>
import { mapState } from "vuex";
import RandomChatMatch from "@/components/randomChat/RandomChatMatch";
import RandomChatCordova from "@/components/randomChat/RandomChatCordova";

export default {
    components: {
        RandomChatMatch,
        RandomChatCordova,
    },
    computed: {
        ...mapState("system", ["cordova"]),
    },
};
</script>
